import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import MarkupTrendSection from "@/features/dashboard/features/markup-trend-section";
import BestSellingSection from "@/features/dashboard/features/best-selling-section";
import TrendingBrandSection from "@/features/dashboard/features/trending-brand-section";
import { useLocation, useSearchParams } from "react-router-dom";
import AppCompanySelect from "@/features/line-sheet-sets/app-company-select";
import { Company } from "@/features/types";
import SVG from "react-inlinesvg";

export default function BuyerDashboardPage() {
  const { tTitle, tSentence } = useI18nHelper();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectBrandAvailable, setSelectBrandAvailable] =
    React.useState<boolean>(true);

  useEffect(() => {
    localStorage.setItem("dashboard-query-string", location.search);
  }, [location]);

  const handleSelect = useCallback(
    (value?: Company[]) => {
      const ids = value?.map((company) => company.id) ?? [];
      //최대 8개
      if (ids.length >= 8) {
        setSelectBrandAvailable(false);
      } else {
        setSelectBrandAvailable(true);
      }
      const params = new URLSearchParams(searchParams);

      params.delete("brand_ids");
      ids.forEach((id) => params.append("brand_ids", String(id)));
      setSearchParams(params, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return (
    <Flex flexDirection={"column"} height={"100%"} maxH={"calc(100vh - 52px)"}>
      <Box
        height={"48px"}
        minHeight={"48px"}
        paddingX={"16px"}
        display={"flex"}
        alignItems={"center"}
        borderBottom={"0.5px solid #D4D4D1"}
        background={"#FFFFFF"}
      >
        <Text textStyle={"heading-sm"}>{tTitle("market_dashboard")}</Text>
      </Box>
      <Box paddingX={"16px"} marginY={"12px"}>
        <AppCompanySelect
          key={"AgencyLineSheetSetListFilter_Brand"}
          name={tTitle("common:select_brand")}
          placeholderText={tSentence("dashboard:select_brand")}
          id={searchParams.getAll("brand_ids").map((id) => Number(id))}
          types={["BRAND"]}
          isMultiple={true}
          onSelect={handleSelect}
          isClearable={false}
          height={"36px"}
          width={"100%"}
          variant={"chip"}
          isDisabled={!selectBrandAvailable}
        />
        <Flex gap={"2px"} alignItems={"center"} marginTop={"6px"}>
          <SVG
            src={"/icons-v1_1/info-circle.svg"}
            width={16}
            height={16}
            color={"#8F8F8C"}
          />
          <Text textStyle={"caption-regular"} textColor={"#6F6F6C"}>
            {tSentence("dashboard:select_brand_tooltip")}
          </Text>
        </Flex>
      </Box>
      <Grid
        paddingX={"16px"}
        paddingBottom={"16px"}
        gap={"16px"}
        width={"100%"}
        // height={"100%"}
        maxH={"calc(100vh - 180px)"}
        templateColumns={"repeat(2, minmax(560px, 1fr))"}
        templateRows={"repeat(2, minmax(278px, 1fr))"}
        aspectRatio={560 / 312}
        background={"#FCFCFB"}
      >
        <Grid
          gap={"16px"}
          width={"100%"}
          height={"100%"}
          maxH={"calc(100vh - 96px)"}
          templateColumns={"repeat(1, minmax(560px, 1fr))"}
          templateRows={"repeat(2, 100%)"}
          aspectRatio={560 / 312}
          background={"#FCFCFB"}
        >
          <TrendingBrandSection />
          <MarkupTrendSection />
        </Grid>
        <Grid
          padding={"0px"}
          gap={"16px"}
          width={"100%"}
          height={"100%"}
          templateColumns={"repeat(1, minmax(560px, 1fr))"}
          templateRows={"repeat(1, calc(200% + 16px))"}
          aspectRatio={560 / 312}
          background={"#FCFCFB"}
        >
          <BestSellingSection />
        </Grid>
      </Grid>
    </Flex>
  );
}
